import './App.scss';
import LoginPage from "./pages/LoginPage"
import ResetPage from "./pages/Reset"
import PasswordResetPage from "./pages/PasswordReset"
import RegisterPage from "./pages/RegisterPage"
import VerifyEmailPage from "./pages/VerifyEmailPage"
import ResentVerifyPage from "./pages/ResendVerifyPage"
import TrialLevelsSelection from "./pages/TrialLevelsSelection"
import Tell from "./gameplay/TellGameplay"
import Test from "./gameplay/TestGameplay"
import Again from "./gameplay/TryAgainGameplay"
import Practice from "./gameplay/Practice"
import Results from "./gameplay/Results"
import NotFound from "./pages/404"
import AppStore from "./pages/AppStore"
import Basket from "./checkout/Basket"
import PaymentCompleted from "./checkout/PaymentCompleted"
import ProtectedRoute from "./router/ProtectedRoute"
import ParentRoleRoute from "./router/ParentRoleRoute"
import ProtectedChildRoute from "./router/ProtectedChildRoute"
import AdultRoute from "./router/AdultRoute"
import TeacherRoleRoute from "./router/TeacherRoleRoute"
import LogoutPage from "./components/authComponents/LogoutPage"
import TransferToChild from "./components/authComponents/TransferToChild"
import Dashboard from "./router/Dashboard"
import Checkout from "./checkout/Checkout"
import Helmet from "react-helmet"
import combinedReducers from "./redux/reducers"
import styled from 'styled-components';

import {
  BrowserRouter as Router,
  Switch, Route, Redirect
} from "react-router-dom"

import { Provider, useSelector } from "react-redux"
import { createStore } from "redux"
import { setAuthToken, loginUser, setUserRole, setLoggedUser } from "./redux/actions"
import SwiperCore, { Navigation, Mousewheel, Autoplay } from 'swiper';
import { ComplaintModal } from "./components"
import { useState } from "react"

const ComplaintButton = styled.div`
  cursor: pointer;
  position: fixed;
  right: 20px;
  bottom: 20px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  width: 50px;
  height: 50px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  &:hover{
    box-shadow: none;
  }
`;
const BetaButton = styled.div`
  background-color: black;
  position: fixed;
  left: 20px;
  bottom: 20px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  color: white;
  border-radius: 10px;
  padding: 5px;
  font-size: 14px;
`;
SwiperCore.use([Navigation, Mousewheel, Autoplay]);

const store = createStore(
  combinedReducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

const authToken = localStorage.getItem('authToken');
const role = localStorage.getItem('role');
const user = JSON.parse(localStorage.getItem('user'));

if (authToken) {
  store.dispatch(setAuthToken(authToken));
  store.dispatch(loginUser());
  store.dispatch(setUserRole(role));
  store.dispatch(setLoggedUser(user));
}

function App() {

  const [modalVisible, setModalVisible] = useState(false);
  return (
    <Provider store={store}>
      <Helmet>
        <script>
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '789017748449176');
            fbq('track', 'PageView');
        `}
        </script>
        <noscript>{`
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=789017748449176&ev=PageView&noscript=1"/>
          `}
        </noscript>
      </Helmet>
      <Router>
        <Switch>
          {/* Redirects */}
          <Route exact path="/" component={LoginPage} />

          {/* <Route exact path="/" component={LoginPage} /> */}

          <Dashboard path="/dashboard" />

          <Route exact path="/register" component={RegisterPage} />
          <Route exact path="/password_forgotten" component={ResetPage} />
          <Route exact path="/resend_verification" component={ResentVerifyPage} />
          <Route exact path="/email/:token" component={VerifyEmailPage} />
          <Route exact path="/password_reset/:token" component={PasswordResetPage} />
          <ProtectedRoute path="/store" exact component={AppStore} />
          <ProtectedRoute path="/test_game/:levelno" component={Test} />
          <ProtectedChildRoute path="/game/:levelno/:gameno/current_game" component={Tell} />
          {/* <AdultRoute path="/explore_trial_levels" component={TrialLevelsSelection} /> */}
          <AdultRoute path="/transfer" component={TransferToChild} />
          <AdultRoute exact path="/payment_completed" component={PaymentCompleted} />
          {/* <ProtectedChildRoute path="/try_again_game/:levelno/:gameno/current_game/:crr_game_id" component={Again} /> */}
          <ProtectedChildRoute path="/try_again_game/:levelno" component={Again} />
          {/* <ProtectedRoute path="/store/checkout" exact component={Checkout} /> */}
          <ProtectedRoute path="/practice/:levelno/:gameno" component={Practice} />
          <ProtectedChildRoute path="/game/results/:levelno/:gameno" exact component={Results} />
          <AdultRoute path="/store/basket" exact component={Basket} />
          <ProtectedRoute path="/logout" exact component={LogoutPage} />
          <Route path="/404" exact component={NotFound} />
          <Route component={NotFound} />

        </Switch>
      </Router>
      <ComplaintButton onClick={() => setModalVisible(true)}>!</ComplaintButton>
      <BetaButton>Live 1.3.1</BetaButton>
      <ComplaintModal visible={modalVisible} onClose={() => setModalVisible(false)} />
    </Provider>
  );
}

export default App;
